import type { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuCustomizationGroupPartnerOptionsQuerySchema } from '~/services/api/generated'

const schema = MenuCustomizationGroupPartnerOptionsQuerySchema.strict()

// MenuCustomizationGroupOptionsRequest
export const MenuCustomizationGroupPartnerOptions = (
  _context: NoContext
): z.ZodType<z.output<typeof schema>> => schema
